module.exports = __webpack_public_path__ + "static/22_tat7-38a07bfa48df20b43441b299f86aa1d7.jpg";